// import React from 'react'; // Not needed in modern React JSX transform
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Provider as JotaiProvider } from 'jotai'
import { AuthProvider } from './contexts/AuthContext'
import { OrganizationProvider } from './contexts/OrganizationContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { ChartPreferencesProvider } from './contexts/ChartPreferencesContext'
import ProtectedRoute from './components/auth/ProtectedRoute'
import LoginForm from './components/auth/LoginForm'
import SignupForm from './components/auth/SignupForm'
import GoogleAuthTest from './components/auth/GoogleAuthTest'
import Home from './pages/Home'
import Charts from './pages/Charts'
import DashboardsPage from './pages/DashboardsPage'
import DataSources from './pages/DataSources'
import Organization from './pages/Organization'
import Profile from './pages/Profile'
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import DashboardViewPage from './pages/DashboardViewPage'
import OAuthCallback from './pages/OAuthCallback'
import DataTableDemo from './pages/DataTableDemo'
import { Toaster } from '@/components/ui/toaster'
// import Header from './components/Header'

function App() {
  return (
    <JotaiProvider>
      <ThemeProvider>
    <AuthProvider>
          <OrganizationProvider>
            <ChartPreferencesProvider>
      <Router>
            <div className="min-h-screen bg-background">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/login" element={<LoginForm />} />
            <Route path="/signup" element={<SignupForm />} />
            <Route path="/test-google" element={<GoogleAuthTest />} />
            <Route path="/auth/google/callback" element={<OAuthCallback />} />
            
            {/* Protected routes */}
            <Route 
              path="/home" 
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Home />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/charts" 
              element={
                <ProtectedRoute>
                  <Charts />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/dashboards" 
              element={
                <ProtectedRoute>
                  <DashboardsPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/organization/:organizationId/dashboards/:dashboardId"
              element={
                <ProtectedRoute>
                  <DashboardViewPage />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/data-sources" 
              element={
                <ProtectedRoute>
                  <DataSources />
                </ProtectedRoute>
              } 
            />

            <Route 
              path="/organization" 
              element={
                <ProtectedRoute>
                  <Organization />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/data-table-demo" 
              element={
                <ProtectedRoute>
                  <DataTableDemo />
                </ProtectedRoute>
              } 
            />
            
            {/* Redirect any unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
            </ChartPreferencesProvider>
          </OrganizationProvider>
    </AuthProvider>
        <Toaster />
      </ThemeProvider>
    </JotaiProvider>
  )
}

export default App 